export default __webpack_public_path__ + "static/media/touchZero.64712dc8.svg";